import PropTypes from 'prop-types';

export const monthlyAvailabilitiesPropTypes = PropTypes.shape({
  data: PropTypes.shape({
    allAvailableDates: PropTypes.arrayOf(PropTypes.string), // e.g. "2024-07-19"
    areas: PropTypes.arrayOf(
      PropTypes.shape({
        areaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        areaName: PropTypes.string,
        sessions: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            availableSizes: PropTypes.arrayOf(
              PropTypes.shape({
                // unknown
              }),
            ),
            allDates: PropTypes.arrayOf(PropTypes.string),
          }),
        ),
      }),
    ),
  }),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool,
});

export const getData = (data) => {
  return {
    ...data,
    allAvailableDates: data?.allAvailableDates, // Ensures that this property is set
  };
};
